import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import WechatUser from './wechat-user';
import WechatUserDetail from './wechat-user-detail';
import WechatUserUpdate from './wechat-user-update';
import WechatUserDeleteDialog from './wechat-user-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={WechatUserUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={WechatUserUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={WechatUserDetail} />
      <ErrorBoundaryRoute path={match.url} component={WechatUser} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={WechatUserDeleteDialog} />
  </>
);

export default Routes;
